import { allSlideTypes } from '@/constant/slideTypes'
import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseSlidePlugin: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-39386-aha-slide-plugin')
  },

  slideActiveConfig: (_, __, rootState) => {
    return allSlideTypes.find((slideType) => slideType.type === rootState.slideActive.type) || {}
  },
}

export default _getters
